<template>
  <div
    :class="$vuetify.breakpoint.mdAndUp ? 'padding-lateral' : ''"
  >
    <Loading v-if="loading" />
    <ErrorServidor v-else-if="erro" />
    <template v-else>
      <template v-if="rastreio.length === 0">
        <v-alert
          class="mt-10 elevation-1"
          dense
          outlined
          type="info"
        >
          <h3>Dados do rastreio não encontrado</h3>
          <p>Ainda não temos o status da sua entrega. Acesse novamente mais tarde.</p>
        </v-alert>
      </template>
      <template v-else>
        <v-row
          no-gutters
          :class="$vuetify.breakpoint.mdAndUp ? 'align-center' : ''"
        >
          <v-col>
            <p
              class="mb-0 mt-2 caption grey--text text--lighten"
              data-cy="vendedor_label"
            >
              Vendedor
            </p>
            <p
              class="body-2 font-weight-bold"
              data-cy="vendedor_nome"
            >
              {{ dadosCompra.vendedor }}
            </p>
          </v-col>
          <v-btn
            :href="linkContato"
            :class="$vuetify.breakpoint.smAndDown ? 'mt-5 pr-0' : ''"
            data-cy="botao_contato"
            target="_blank"
            color="primary"
            :outlined="$vuetify.breakpoint.mdAndUp"
            text
            :width="$vuetify.breakpoint.mdAndUp ? '188' : ''"
          >
            Contato
          </v-btn>
        </v-row>
        <TituloPagina :titulo="tituloDaPagina" class="mt-6 mb-4 mt-md-4" />
        <v-timeline
          dense
          align-top
          class="pt-0 mb-8 pt-md-1"
        >
          <v-timeline-item
            v-for="(item, index) in rastreio"
            :key="item.message"
            fill-dot
            data-cy="rastreio_timeline"
            small
            :class="{ 'active': index === 0 }"
          >
            <v-card
              class="px-5 py-4 grey--text text--darken-2"
              min-height="90"
              data-cy="card_item_rastreio"
            >
              <p data-cy="rastreio_timeline_data_hora">
                <strong class="title">
                  <span data-cy="rastreio_timeline_data">
                    {{ item.date | dataFormatada('numeric', '2-digit', '2-digit') }}
                  </span>,
                </strong>
                <span class="grey--text text--lighten-1">
                  {{ item.hour }}
                </span>
              </p>
              <p>
                <strong>
                  Status
                </strong> {{ item.description }}
              </p>
              <p class="mb-0">
                <strong>
                  Local
                </strong> {{ item.location }}
              </p>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </template>

      <BtnVoltar
        v-if="$vuetify.breakpoint.smAndDown"
        :to="urlVoltar"
        max-width="700px"
      />
      <v-btn
        v-if="$vuetify.breakpoint.mdAndUp && !loading"
        :to="urlVoltar"
        class="mt-5"
        color="primary"
        data-cy="btn_voltar"
        outlined
        width="278"
      >
        Voltar
      </v-btn>
    </template>
  </div>
</template>

<script>

import ApiCompras from '@/api/compras';
import { mapActions, mapGetters, mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import BtnVoltar from '@/components/BtnVoltar.vue';
import ErrorServidor from '@/components/ErrorServidor.vue';

export default {
  name: 'RastreioTimeline',

  components: {
    TituloPagina,
    BtnVoltar,
    Loading,
    ErrorServidor,
  },

  props: {
    compraId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      tituloDaPagina: 'Acompanhar envio',
      loading: true,
      rastreio: [],
      erro: false,
    };
  },

  computed: {
    ...mapGetters(['dadosCompra']),
    ...mapState(['dadosTransacao']),

    urlVoltar() {
      const { id } = this.dadosTransacao;
      return `/minhas-compras/detalhe-compra/${id}`;
    },

    linkContato() {
      if (this.dadosCompra.vendedorWhatsapp) {
        const subdominio = this.$vuetify.breakpoint.mdAndUp ? 'web' : 'api';

        return `https://${subdominio}.whatsapp.com/send?l=pt_BR&phone=55${this.dadosCompra.vendedorWhatsap}`;
      }

      if (this.$vuetify.breakpoint.mdAndUp || !this.dadosCompra.vendedorTelefone) {
        if (this.dadosCompra.vendedorEmail) {
          return `mailto:${this.dadosCompra.vendedorEmail}`;
        }

        if (this.dadosCompra.vendedorCentralDeAjuda) {
          return this.dadosCompra.vendedorCentralDeAjuda;
        }
      }

      return `tel:${this.dadosCompra.vendedorTelefone}`;
    },
  },

  created() {
    this.verificarStore();
  },

  methods: {
    ...mapActions(['setDadosTransacao']),

    async carregarRastreio() {
      await ApiCompras.orderTracking(this.dadosTransacao.tracking_code,
        this.dadosTransacao.tracking_service_slug)
        .then((response) => {
          this.rastreio = response.data.data;
        })
        .catch(() => {
          this.erro = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async getApi(id) {
      this.erro = false;

      await ApiCompras.orderDetails(id)
        .then((response) => {
          this.data = response.data;
          this.setDadosTransacao(this.data);
          this.carregarRastreio();
        })
        .catch(() => {
          this.erro = true;
        });
    },

    verificarStore() {
      if (this.dadosTransacao.id === this.compraId) {
        this.carregarRastreio();
      } else {
        this.getApi(this.compraId);
      }
    },
  },

};
</script>

<style lang="scss" scope>
@import '~@/scss/timeline.scss';

.padding-lateral { padding: 0 100px; }
</style>
